import { FC } from 'react';

import { Image } from '../Image/Image';

interface Props {}

const LOGO_WIDTH = 120;
const LOGO_HEIGHT = 72;

export const HeaderMenuLogo: FC<Props> = () => (
  <Image
    src="https://img.carma.com.au/brand/carma-logo.svg"
    alt="Carma"
    className="block aspect-[120/72] w-full object-contain object-top"
    width={LOGO_WIDTH}
    height={LOGO_HEIGHT}
    priority
    data-testid="carma-logo"
  />
);
